export default function MCRunVersionSelector({ runs = [], value, onChange }) {
  return (
    <select className="rounded-lg border px-3 py-2 text-sm" value={value || ''} onChange={(e) => onChange(e.target.value)}>
      <option value="">Seleccionar versión</option>
      {runs.map((run, index) => (
        <option key={run.id} value={run.id}>v{runs.length - index} - {new Date(run.createdAt).toLocaleString()}</option>
      ))}
    </select>
  )
}
